import React, { useState, useEffect } from "react"
import { useGlobalState } from "../contexts/GlobalStateContext"
import axios from 'axios'

const HomeDownload = () => {
    const { t, API_PATH} = useGlobalState()
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(false)
    const [commHref, setCommHref] = useState("")
    const [commFileName, setCommFileName] = useState("Assessment-Kommunikation")
    const [thinkHref, setThinkHref] = useState("")
    const [thinkFileName, setThinkFileName] = useState("Assessment-Denkstil")

    const params = new URLSearchParams(window.location.search)
    const res_id = params.get("res_id")

    const isUUIDLength = (value) => typeof value === "string" && value.length === 36;

    useEffect(() => {
        let isMounted = true;
    
        if (isMounted) {
          if (res_id && isUUIDLength(res_id)) {
            axios.get(API_PATH + "download-assessments-files.php", {
                params: {
                  res_id: res_id,
                },
              })
              .then((res) => {
                if (!res.data || (Array.isArray(res.data) && res.data.length === 0)) {
                  setError(t("Home.applicant_not_ready"));
                } else {
                  if (res.data.Comm.datas){
                    setCommHref(`data:application/pdf;base64,${res.data.Comm.datas}`);
                    if (res.data.Comm.filename){
                      const commFileName = res.data.Comm.filename.split('/').pop(); 
                      setCommFileName(commFileName);
                    }
                  }
                  if (res.data.Think.datas){
                    setThinkHref(`data:application/pdf;base64,${res.data.Think.datas}`);
                    if (res.data.Think.filename){
                      const thinkFileName = res.data.Think.filename.split('/').pop(); 
                      setThinkFileName(thinkFileName);
                    }
                  }
                  setLoading(false);
                }
                
              })
              .catch((e) => {
                setError(e.message);
              });
    
          } else {
            setError(t("Home.alert_user_not_found"));
          }
        }

        return () => {
          isMounted = false;
        };
      }, [res_id, t, API_PATH]);

    const renderDownloadPage = () => {
        return (<>
            <div id="heartily-welcome">
                <h4 style={{ paddingBottom: "20px"}}>{t('Home.download_documents')}</h4>
                {commHref ?
                    <a href={commHref} download={commFileName}>
                      <button className='btn btn-primary'>📄 Urkunde Assessment Kommunikation (Download)</button>
                    </a>
                    : <p>{t('Home.missing_document')}</p>
                }
                {thinkHref ?
                    <a href={thinkHref} download={thinkFileName}>
                      <button className='btn btn-primary'>📄 Urkunde Assessment Denkstil (Download)</button>
                    </a>
                    : <p>{t('Home.missing_document')}</p>
                }
            </div>
        </>)
    }

    return (
        <div id='main-text' className='col-lg-9 m-3 text-center d-flex flex-column align-items-center'>
            {!error ? <>
                {!loading ?
                    renderDownloadPage()
                    : <h4>{t("App.loading")}</h4>
                }
            </> : <>
                <h4 className='m-3'>{t('Home.download_documents')}</h4>
                <p>{error}</p>
            </>}
        </div >
    )
}

export default HomeDownload
